import { AnyAction } from 'redux';

import {
    CLOSE_MENUS,
    CLOSE_MOBILENAVMENU,
    CLOSE_PHONEMENU,
    CLOSE_SUBMENU,
    OPEN_MOBILENAVMENU,
    OPEN_PHONEMENU,
    OPEN_SUBMENU,
    TOGGLE_STICKY_EMAIL_GUIDE,
    TOGGLE_ZIPMODAL,
    UPDATE_ADOBE_TESTING,
    UPDATE_PC_CENSUS,
    UPDATE_TOGGLE,
} from '../Actions/DisplayActions';

import initialState from './DisplayInitialState';

const reducer = (state = initialState, action: AnyAction): typeof initialState => {
    switch (action.type) {
        case OPEN_MOBILENAVMENU:
            return {
                ...state,
                subMenuOpen: '',
                phoneMenuOpen: false,
                mobileNavMenuOpen: true,
            };
        case CLOSE_MOBILENAVMENU:
            return {
                ...state,
                subMenuOpen: '',
                mobileNavMenuOpen: false,
            };
        case OPEN_PHONEMENU:
            return {
                ...state,
                subMenuOpen: '',
                mobileNavMenuOpen: false,
                phoneMenuOpen: true,
            };
        case CLOSE_PHONEMENU:
            return {
                ...state,
                subMenuOpen: '',
                phoneMenuOpen: false,
            };
        case OPEN_SUBMENU:
            return {
                ...state,
                subMenuOpen: action.payload as typeof initialState.subMenuOpen,
                mobileNavMenuOpen: false,
            };
        case CLOSE_SUBMENU:
            return {
                ...state,
                subMenuOpen: '',
            };
        case CLOSE_MENUS:
            return {
                ...state,
                mobileNavMenuOpen: false,
                phoneMenuOpen: false,
                subMenuOpen: '',
            };
        case TOGGLE_STICKY_EMAIL_GUIDE:
            return {
                ...state,
                stickyGuideOpen: action.payload as boolean,
            };
        case TOGGLE_ZIPMODAL:
            return {
                ...state,
                zipModalOpen: action.payload as boolean,
            };
        case UPDATE_ADOBE_TESTING:
            return {
                ...state,
                adobeTesting: action.payload as typeof initialState.adobeTesting,
            };
        case UPDATE_PC_CENSUS:
            return {
                ...state,
                personalCode: action.payload as typeof initialState.personalCode,
            };
        case UPDATE_TOGGLE:
            return {
                ...state,
                toggleActive: (action.payload as Record<string, boolean>).toggleActive,
            };
        default:
            return state;
    }
};
export default reducer;
